import script from "./OmnichannelLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OmnichannelLayout.vue?vue&type=script&setup=true&lang=js"

import "./OmnichannelLayout.vue?vue&type=style&index=0&id=90299d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90299d2e"]])

export default __exports__